export default "__VITE_ASSET__ccf5008f__"